import { grayColor } from "assets/jss/style.js";

const footerStyle = {
  footerContent: {
    background: grayColor
  }
};
export default footerStyle;
